import { useState, createContext, useContext, useEffect } from "react";
import pagesNames from "./constants/pages-names";
import Layout from "./layouts/Layout";
import CommitmentsPage from "./pages/CommitmentsPage";
import HomePage from "./pages/HomePage";
import InsightsPage from "./pages/InsightsPage";
import JourneyPage from "./pages/JourneyPage";
// import LoadingPage from './pages/LoadingPage';
import NewsPage from "./pages/NewsPage";
import ResourcesPage from "./pages/ResourcesPage";
import StatementsPage from "./pages/StatementsPage";
import StrategyPage from "./pages/StrategyPage";
import EmissionsPage from "./pages/Subpages/EmissionsPage";
import EnvironmentPage from "./pages/Subpages/EnvironmentPage";
import SaudiGreenPage from "./pages/Subpages/SaudiGreenPage";
import TransitionPage from "./pages/Subpages/TransitionPage";
import VisionPage from "./pages/Subpages/VisionPage";
import "./sass/App.scss";
import PageContextType from "./types/PageContextType";
import SocialPage from "./pages/Subpages/SocialPage";
import GovernancePage from "./pages/Subpages/GovernancePage";
import SustainableFinancingPage from "./pages/Subpages/SustainableFinancingPage";
import MaterialPage from "./pages/Subpages/MaterialPage";
import ESGProfilePage from "./pages/Subpages/ESGProfilePage";
import SingleNewsPostPage from "./pages/Subpages/SingleNewsPostPage";
import SingleInsightPostPage from "./pages/Subpages/SingleInsightPostPage";
import insightPageData from "./data/english/subpages/insight-page-data";
import newsPageData from "./data/english/subpages/news-page-data";
import HomePageAr from "./pages/arabic/HomePageAr";
import CommitmentsPageAr from "./pages/arabic/CommitmentsPageAr";
import InsightsPageAr from "./pages/arabic/InsightsPageAr";
import JourneyPageAr from "./pages/arabic/JourneyPageAr";
import ResourcesPageAr from "./pages/arabic/ResourcesPageAr";
import NewsPageAr from "./pages/arabic/NewsPageAr";
import StatementsPageAr from "./pages/arabic/StatementsPageAr";
import StrategyPageAr from "./pages/arabic/StrategyPageAr";
import EnvironmentPageAr from "./pages/arabic/Subpages/EnvironmentPageAr";
import TransitionPageAr from "./pages/arabic/Subpages/TransitionPageAr";
import SaudiGreenPageAr from "./pages/arabic/Subpages/SaudiGreenPageAr";
import EmissionsPageAr from "./pages/arabic/Subpages/EmissionsPageAr";
import VisionPageAr from "./pages/arabic/Subpages/VisionPageAr";
import SocialPageAr from "./pages/arabic/Subpages/SocialPageAr";
import GovernancePageAr from "./pages/arabic/Subpages/GovernancePageAr";
import SustainableFinancingPageAr from "./pages/arabic/Subpages/SustainableFinancingPageAr";
import MaterialPageAr from "./pages/arabic/Subpages/MaterialPageAr";
import ESGProfilePageAr from "./pages/arabic/Subpages/ESGProfilePageAr";
import SingleNewsPostPageAr from "./pages/arabic/Subpages/SingleNewsPostPageAr";
import SingleInsightPostPageAr from "./pages/arabic/Subpages/SingleInsightPostPageAr";
import HighlightPage from "./pages/Subpages/HighlightPage";
import HighlightPageAr from "./pages/arabic/Subpages/HighlightPageAr";
import ReportsPageAr from "./pages/arabic/Subpages/ReportsPageAr";
import ReportsPage from "./pages/Subpages/ReportsPage";
import CompliancePage from "./pages/Subpages/CompliancePage";
import CompliancePageAr from "./pages/arabic/Subpages/CompliancePageAr";
import CSRPage from "./pages/Subpages/CSRPage";
import CSRPageAr from "./pages/arabic/Subpages/CSRPageAr";
import EmbeddingPageAr from "./pages/arabic/Subpages/EmbeddingPageAr";
import EmbeddingPage from "./pages/Subpages/EmbeddingPage";
import InternationalFrameworkPage from "./pages/Subpages/InternationalFrameworkPage";
import InternationalFrameworksPageAr from "./pages/arabic/Subpages/InternationalFrameworksPageAr";
import BusinessStartegyPage from "./pages/Subpages/BusinessStartegyPage";
import BusinessStartegyPageAr from "./pages/arabic/Subpages/BusinessStartegyPageAr";
import RiskPage from "./pages/Subpages/RiskPage";
import RiskPageAr from "./pages/arabic/Subpages/RiskPageAr";
import StakeholdersPageAr from "./pages/arabic/Subpages/StakeHolderPageAr";
import StakeholdersPage from "./pages/Subpages/StakeholdersPage";
import SustainableProductPage from "./pages/Subpages/SustainableProductPage";
import SustainableProductsPageAr from "./pages/arabic/Subpages/SustainableProductsPageAr";
import insightPageDataAr from "./data/arabic/subpages/insight-page-data-ar";

const pages = [
  [
    {
      title: pagesNames.home,
      page: HomePage,
    },
    {
      title: pagesNames.commitments,
      page: CommitmentsPage,
    },
    {
      title: pagesNames.insight,
      page: InsightsPage,
    },
    {
      title: pagesNames.journey,
      page: JourneyPage,
    },
    {
      title: pagesNames.resource,
      page: ResourcesPage,
    },
    {
      title: pagesNames.news,
      page: NewsPage,
    },
    {
      title: pagesNames.statements,
      page: StatementsPage,
    },
    {
      title: pagesNames.starategy,
      page: StrategyPage,
    },
    {
      title: pagesNames.environment,
      page: EnvironmentPage,
    },
    {
      title: pagesNames.transition,
      page: TransitionPage,
    },
    {
      title: pagesNames.saudiGreen,
      page: SaudiGreenPage,
    },
    {
      title: pagesNames.emissions,
      page: EmissionsPage,
    },
    {
      title: pagesNames.vision,
      page: VisionPage,
    },
    {
      title: pagesNames.social,
      page: SocialPage,
    },
    {
      title: pagesNames.governance,
      page: GovernancePage,
    },
    {
      title: pagesNames.sustainableFinancing,
      page: SustainableProductPage,
    },
    {
      title: pagesNames.materials,
      page: MaterialPage,
    },
    {
      title: pagesNames.esgProfile,
      page: ESGProfilePage,
    },
    {
      title : pagesNames.singleNewsPost,
      page : SingleNewsPostPage,
    },
    {
      title : pagesNames.singleInsightPost,
      page : SingleInsightPostPage,
    },
    {
      title : pagesNames.highlight,
      page : HighlightPage,
    },
    {
      title : pagesNames.reports,
      page : ReportsPage,
    },
    {
      title : pagesNames.compliance,
      page : CompliancePage,
    },
    {
      title : pagesNames.csr,
      page : CSRPage,
    },
    {
      title : pagesNames.embedding,
      page : EmbeddingPage,
    },
    {
      title : pagesNames.frameworks,
      page : InternationalFrameworkPage,
    },
    {
      title : pagesNames.business,
      page : BusinessStartegyPage,
    },
    {
      title : pagesNames.risk,
      page : RiskPage,
    },
    {
      title : pagesNames.stakeholders,
      page : StakeholdersPage,
    },
  ],
  [
    {
      title : pagesNames.home,
      page : HomePageAr,
    },
    {
      title: pagesNames.commitments,
      page: CommitmentsPageAr,
    },
    {
      title: pagesNames.insight,
      page: InsightsPageAr,
    },
    {
      title: pagesNames.journey,
      page: JourneyPageAr,
    },
    {
      title: pagesNames.resource,
      page: ResourcesPageAr,
    },
    {
      title: pagesNames.news,
      page: NewsPageAr,
    },
    {
      title: pagesNames.statements,
      page: StatementsPageAr,
    },
    {
      title: pagesNames.starategy,
      page: StrategyPageAr,
    },
    {
      title: pagesNames.environment,
      page: EnvironmentPageAr,
    },
    {
      title: pagesNames.transition,
      page: TransitionPageAr,
    },
    {
      title: pagesNames.saudiGreen,
      page: SaudiGreenPageAr,
    },
    {
      title: pagesNames.emissions,
      page: EmissionsPageAr,
    },
    {
      title: pagesNames.vision,
      page: VisionPageAr,
    },
    {
      title: pagesNames.social,
      page: SocialPageAr,
    },
    {
      title: pagesNames.governance,
      page: GovernancePageAr,
    },
    {
      title: pagesNames.sustainableFinancing,
      page: SustainableProductsPageAr,
    },
    {
      title: pagesNames.materials,
      page: MaterialPageAr,
    },
    {
      title: pagesNames.esgProfile,
      page: ESGProfilePageAr,
    },
    {
      title : pagesNames.singleNewsPost,
      page : SingleNewsPostPageAr,
    },
    {
      title : pagesNames.singleInsightPost,
      page : SingleInsightPostPageAr,
    },
    {
      title : pagesNames.highlight,
      page : HighlightPageAr,
    },
    {
      title : pagesNames.reports,
      page : ReportsPageAr,
    },
    {
      title : pagesNames.compliance,
      page : CompliancePageAr,
    },
    {
      title : pagesNames.csr,
      page : CSRPageAr,
    },
    {
      title : pagesNames.embedding,
      page : EmbeddingPageAr,
    },
    {
      title : pagesNames.frameworks,
      page : InternationalFrameworksPageAr,
    },
    {
      title : pagesNames.business,
      page : BusinessStartegyPageAr
    },
    {
      title : pagesNames.risk,
      page : RiskPageAr,
    },
    {
      title : pagesNames.stakeholders,
      page : StakeholdersPageAr,
    },
  ],
];

export type PageType = {
  name: string;
  pageId: number;
};

export const PageContext = createContext<PageContextType>({
  currentPage: pagesNames.home,
  handleChangePage: (pageName: PageType) => {},
  toggleMenu: false,
  submenuIndex: 0,
  setToggleMenu: (value: boolean) => {},
  setSubmenuIndex: (value: number) => {},
});

type NewsContextType = {
  currentNewsData: {
    title: string;
    shortDescription: string;
    content: JSX.Element;
    image: {
      name: string;
      alt: string;
    };
  };
  handleChangeCurrentNewsData: (sectionIndex: number, articleIndex: number) => void;
};
type InsightContextType = {
  currentInsightDataIndex: number;
  handleChangeCurrentInsightData: (articleIndex: number) => void;
};

export const NewsContext = createContext<NewsContextType>({
  currentNewsData: newsPageData.sections[0].articles[0],
  handleChangeCurrentNewsData: () => {},
});

export const InsightContext = createContext<InsightContextType>({
  currentInsightDataIndex : 0,
  handleChangeCurrentInsightData : () => {},
})

type LangContextType = {
  lang: number;
  handleChangeLang : (langNumber : number) => void;
}

export const LangContext = createContext<LangContextType>({
  lang : 0,
  handleChangeLang : () => {},
})

function App() {
  const [lang, setLang] = useState<number>(0);

  useEffect(()=>{
    const searchParms = new URLSearchParams(window.location.search);
    const queryParameter = searchParms.get('page');
    const pageName = queryParameter && document.querySelector(`#${queryParameter}`) as HTMLElement;
    if(pageName) {
      pageName?.click();
      setTimeout(() => {
        pageName?.click()
      }, 100);
    }
    console.log(queryParameter,pageName)
  },[])

  const [toggleMenu, setToggleMenu] = useState<boolean>(false);
  const [submenuIndex, setSubmenuIndex] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<PageType>(pagesNames.home);
  const [currentNewsData, setCurrentNewsData] = useState(
    newsPageData.sections[0].articles[0]
  );
  const [currentInsightDataIndex, setCurrentInsightDataIndex] = useState(0)
  // const [loading, setLoading] = useState<boolean>(false);

  const handleChangePage = (pageName: PageType): void => {
    setSubmenuIndex(0);
    setToggleMenu(false);
    document.getElementById("main")?.scrollTo({ top: 0 });
    setCurrentPage(pageName);
  };

  const handleChangeCurrentNewsData = (
    sectionIndex: number,
    articleIndex: number
  ) => {
    setCurrentNewsData(
      newsPageData.sections[sectionIndex].articles[articleIndex]
    );
    handleChangePage(pagesNames.singleNewsPost);
  };

  const insightPageContent = [
    insightPageData,
    insightPageDataAr,
  ]

  const handleChangeCurrentInsightData = (aritcleIndex : number) => {
    setCurrentInsightDataIndex(aritcleIndex)
    handleChangePage(pagesNames.singleInsightPost);
  }

  const handleChangeLang = (langNumber : number) => {
    setLang(langNumber);
    if (langNumber === 0) {
      document.documentElement.setAttribute("lang", "en");
    } else {
      document.documentElement.setAttribute('lang', 'ar')
    }
  }

  // const [loadingTime, setLoadingTime] = useState<number>(0);
  // useEffect(() => {
  //   if (loading) {
  //     setLoadingTime(window.performance.now());
  //   }
  // }, [loadingTime])

  // const getBasename = (path : any) => path.substr(0, path.lastIndexOf("/"));

  return (
    <LangContext.Provider
      value={{
        lang : lang,
        handleChangeLang : handleChangeLang,
      }}
    >

    <InsightContext.Provider
      value={{
        currentInsightDataIndex : currentInsightDataIndex,
        handleChangeCurrentInsightData : handleChangeCurrentInsightData,
      }}
    >
    <NewsContext.Provider
      value={{
        currentNewsData : currentNewsData,
        handleChangeCurrentNewsData : handleChangeCurrentNewsData,
      }}
    >
    <PageContext.Provider
      value={{
        toggleMenu: toggleMenu,
        submenuIndex: submenuIndex,
        setSubmenuIndex: setSubmenuIndex,
        setToggleMenu: setToggleMenu,
        currentPage: currentPage,
        handleChangePage: handleChangePage,
      }}
    >
        <div
          className={`App ${lang === 0 ? "" : "arabic"}`}
          // onLoadStart={() : void => setLoading(true)}
          // onLoadedData={() : void => {
          //   setInterval(() => {
          //     setLoading(false)
          //   }, 2000)
          // }}
        >
          {/* {loading ? <LoadingPage time={0} fullTime={window.performance.measure("end").duration} /> : ""} */}
          <Layout>
            {pages[lang].find(({ title }) => title === currentPage)?.page()}
          </Layout>
        </div>
    </PageContext.Provider>
    </NewsContext.Provider>
    </InsightContext.Provider>
    </LangContext.Provider>
    // <TestPage />
  );
}

export default App;
